import { AiOutlineCheckCircle, AiOutlineClose, AiFillWarning, AiTwotoneAlert } from 'react-icons/ai';

type Props = {
  message: string;
  show?: boolean;
  typeIcon: string;
  onClose?: () => void;
};

const Alert = ({ message, onClose, show = true, typeIcon }: Props) => {
  return (
    <div
      className={
        'my-4 flex w-full items-start justify-between gap-3 rounded-lg bg-[#f8f8f8] p-4 shadow-lg ' +
        (show ? '' : 'hidden')
      }
    >
      <div className="flex min-w-0 flex-1 items-start gap-3">
        {typeIcon === 'warning' && (
          <AiFillWarning color="#FFC107" size={28} className="mt-0.5 shrink-0" />
        )}
        {typeIcon === 'success' && (
          <AiOutlineCheckCircle color="#06C051" size={28} className="mt-0.5 shrink-0" />
        )}
        {typeIcon === 'error' && (
          <AiTwotoneAlert color="#E52D2D" size={28} className="mt-0.5 shrink-0" />
        )}
        <h4 className="text-md font-semibold leading-relaxed text-[#000000]">{message}</h4>
      </div>
      {onClose ? (
        <button
          type="button"
          aria-label="Close"
          onClick={onClose}
          className="mt-0.5 shrink-0 cursor-pointer rounded p-1 text-slate-600 hover:bg-slate-200/70 hover:text-slate-900"
        >
          <AiOutlineClose size={22} />
        </button>
      ) : null}
    </div>
  );
};

export { Alert };
